import { all, fork } from "redux-saga/effects";
import { categorySaga } from "./category";
import { bannerAdsSaga } from "./banner-ads";

export function* rootSaga() {
  yield all([fork(categorySaga), fork(bannerAdsSaga)]);
}
